import RatingEntityContent from '@/components/entity-detail/components/Entity/RatingEntity';
import type { TDetailServiceParams } from '@/components/entity-detail/types/EntityType.types';
import { userService } from '@/services/rest';
import type { ApiResponse } from '@/types/common/api.type';
import { t } from '@/utils/lang';
import { Entity } from '../entity';

export class RatingEntity extends Entity {
    public getTitleTemplate(response?: string): string {
        if (!response) {
            return t('Đánh giá');
        }

        return `${t('Đánh giá của nhân viên')}:`;
    }

    public getEntityComponent(): any {
        return RatingEntityContent;
    }

    public getIncludeProperties() {
        return {};
    }

    public getDetailService(
        params: TDetailServiceParams
    ): Promise<ApiResponse<any>> {
        return userService().detail(params.id, {
            ...this.getIncludeProperties(),
            ...params,
        });
    }

    public getFieldName(): string {
        return 'fullname';
    }

    public getDetailUrl(id: string): string {
        return this.routeManager.getRouteMap()[this.getRouteDetail()].path(id);
    }

    public showDetailButton(): boolean {
        return true;
    }

    public getRouteDetail(): string {
        return this.routeManager.STAFF_DETAIL;
    }
}
